export const hcConfig = window.$hcConfig;
export const isPeerStream = hcConfig.isPeerStream;
export const clientWidth = hcConfig.clientWidth;
export const clientHeight = hcConfig.clientHeight;
export const isAdapt = hcConfig.isAdapt;
export const ueServer = hcConfig.ueServer;
export const ueTimeOut = hcConfig.ueTimeOut;
export const isSwitch = hcConfig.isSwitch;
